<template>
    <div>
        <stats :headline="headline">
            <stat :name="$t('shared.modals.adjust_max_price_modal.adjust_overview.max_price')"
                :value="maxPrice"/>
        </stats>
    </div>
</template>

<script>

import { Link } from '@inertiajs/vue2';
import Stat from "../Stat";
import Stats from "../Stats";

export default {
    components: {
        Link,
        Stats,
        Stat
    },
    props: {
        headline: String,
        maxPrice: Number,
        boldHeadline: {
            type: Boolean,
            default: false
        }
    }
}
</script>
